export const lineHeights = {
  $0: 14.5,
  $1: 15.7,
  $2: 17,
  $3: 19,
  $4: 24,
  $5: 29,
  $6: 34,
  $7: 39,
  $8: 58.1,
  $9: 73
};

export const space = {
  $0: 0,
  $1: 4,
  $2: 8,
  $3: 12,
  $4: 16,
  $5: 20,
  $6: 24,
  $7: 28,
  $8: 32,
  $9: 36,
  $10: 40,
  $11: 44,
  $12: 48,
  $13: 52,
  $14: 56,
  $15: 60,
  $16: 64,
  $17: 68,
  $18: 72,
  $19: 76,
  $20: 80,
  $25: 100,
  $30: 120,
  $35: 140,
  $40: 160,
  $43: 172,
  $50: 200,
  $52: 210,
  $60: 240,
  $70: 280,
  $75: 300,
  $80: 320,
  $90: 360,
  $100: 400,
  $110: 440,
  $120: 480,
  $130: 520,

  // Radius
  $radius0: 0,
  $radius1: 5,
  $radius2: 10,
  $radius3: 15,
  $radius4: 20,
  $radius5: 25,
  $radius6: 30,
  $radius7: 35,
  $radius8: 40
};

export const sizes = {
  ...space,
  $maxDesktopScreenWidth: 1620
};
